export default __webpack_public_path__ + "static/media/img3.66751ac2.png";